/* eslint-disable max-len */
import { experimental_extendTheme as extendTheme, responsiveFontSizes } from '@mui/material/styles'

const customTheme = extendTheme({
  cssVarPrefix: 'outvoice',
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: '#311b92',
        },
        secondary: {
          main: '#f50057',
        },
        error: {
          main: '#d50000',
        },
        success: {
          main: '#00c853',
        },
        info: {
          main: '#0091ea',
        },
        background: {
          default: '#f5f4fa',
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: '#7e57c2',
        },
        secondary: {
          main: '#f50057',
        },
        error: {
          main: '#d50000',
        },
        success: {
          main: '#00c853',
        },
        info: {
          main: '#0091ea',
        },
      },
    },
  },
  typography: {
    fontFamily: 'PT Sans',
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    h1: {
      fontFamily: 'Roboto Slab',
      fontWeight: 500,
      fontSize: '3rem',
      lineHeight: 1.2,
    },
    h2: {
      fontFamily: 'Roboto Slab',
      fontSize: '2.4rem',
      fontWeight: 500,
      color: '#311b92',
    },
    h3: {
      fontFamily: 'Roboto Slab',
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: 'Roboto Slab',
      fontSize: '1.2rem',
      fontWeight: 500,
      lineHeight: 1.2,
    },
    h5: {
      fontFamily: 'Roboto Slab',
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.2,
    },
    h6: {
      fontFamily: 'Roboto Slab',
      fontSize: '0.8rem',
      lineHeight: 1.2,
    },
    button: {
      fontSize: '1.1rem',
      textTransform: 'none',
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxSizing: 'border-box',
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: 16,
        },
        spacing: 2,
      },
    },
    MuiBottomNavigation: {
      styleOverrides: {
        root: ({ theme: { palette } }) => ({
          backgroundColor: palette.primary.mainChannel,
        }),
      },
    },
    // MuiDataGrid: {
    //   styleOverrides: {
    //     root: {
    //       fontWeight: 'bold',
    //     },
    //   },
    // },
  },
})

export const responsiveTheme = responsiveFontSizes(customTheme)
